// extracted by mini-css-extract-plugin
export var compactFilters = "_eu-4";
export var detailImage = "_eu-1";
export var dropdownContainer = "_eu-2";
export var imageContainer = "_eu-0";
export var selectedCard = "_eu-3";